module.exports = __webpack_public_path__ + "images/loading_icon_60x60.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/loading_icon_60x60.png
// module id = 871
// module chunks = 126